import firebase from "firebase/app";
import "@firebase/messaging";

import { setFCMToken } from "./backend-helpers/member";

export const initializeFirebase = config => {

    if (!firebase.apps.length) {
        firebase.initializeApp(config);
    }

    if (firebase.messaging.isSupported()) {
        const messaging = firebase.messaging();
        messaging.getToken().then((currentToken) => {
            if (currentToken) {
                sendTokenToServer(currentToken);
            } else {
                console.log('No Instance ID token available. Request permission to generate one.');
                setTokenSentToServer(false);
            }
        }).catch((err) => {
            console.log('An error occurred while retrieving token. ', err);
            setTokenSentToServer(false);
        });

        // fired when FCM has invalidated existing token
        messaging.onTokenRefresh(() => {
            messaging.getToken().then((refreshedToken) => {
                console.log('Token refreshed.');
                // Indicate that the new Instance ID token has not yet been sent to the app server.
                setTokenSentToServer(false);
                // Send Instance ID token to app server.
                sendTokenToServer(refreshedToken);
            }).catch((err) => {
                console.log('Unable to retrieve refreshed token ', err);
            });
        });

        messaging.onMessage((payload) => {
            console.log('Message received. ', payload);
        });
    }
};

function sendTokenToServer(token) {
    //console.log(token);
    if (!isTokenSentToServer()) {
        //console.log('Sending token to server...');
        setFCMToken({ token })
            .then(() => {
                setTokenSentToServer(true);
                //console.log('Token successfully sent to server');
            })
            .catch(err => console.log('Something went wrong when sent token', err))
    } else {
        //console.log('Token already sent to server so won\'t send it again unless it changes');
    }
}

export const requestPermission = () => {
    Notification.requestPermission()
        .then(() => console.log("Notifications permission granted"))
        .catch(() => console.log("Please unblock notification request manually"))
};

function setTokenSentToServer(sent) {
    window.localStorage.setItem('sentToServer', sent ? '1' : '0');
}

function isTokenSentToServer() {
    return window.localStorage.getItem('sentToServer') === '1';
}



// WEBPACK FOOTER //
// ./src/firebase.js